import { IAuthUserPerfil, AuthUserPerfilId } from './IAuthUserPerfil';

export default ((): IAuthUserPerfil => {
  return {
    id: AuthUserPerfilId.AssessorConsulta,
    nome: "Consulta",

    associadoRoute: {
      assembleias: {
        pre: {
          ver: false,
          videos: {
            ver: false,
            participar: false
          },
          documentos: {
            ver: false,
            participar: false,
          },
          duvidasSugestoes: {
            ver: false,
            participar: false
          }
        },
        live: {
          ver: false,
          video: {
            ver: false,
            participar: false
          },
          documentos: {
            ver: false,
            participar: false,
          },
          duvidasSugestoes: {
            ver: false,
            participar: false
          }
        },
        pautas: {
          ver: false,
          participar: false
        }
      },
    },
  
    assessorRoute: {
      convocados: {
        view: true,
      },
      assembleias: {
        ver: true,
        alterarSituacao: false,
        bloquearConvocacao: false,
        convocar: false,
        documentos: {
          ver: true,
          editar: false,
        },
        participantes: {
          verTotal: true,
          confirmar: true
        },
        pautas: {
          ver: true,
          alterarSituacao: false,
          incluirVotoManual: true,
          editar: false,
          deletar: false
        },
        cadastroPauta: {
          cadastrar: false
        },
        videos: {
          editar: false,
        }
      },
  
      duvidasSugestoes: {
        ver: true,
        responder: false,
        alterarSituacao: false,
        incluirPergunta: false,
      }
    }
    
  }
})();